// extracted by mini-css-extract-plugin
module.exports = {"card":"TaskCard_card__vK_dZ","text":"TaskCard_text__HJQ_v","center":"TaskCard_center__9EUEl","row":"TaskCard_row__XPWcI","leftMargin":"TaskCard_leftMargin__5JD5R"};